import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import AppAppBar from '../AppAppBar';
import Footer from '../Footer';

export default function Contact({ mode, toggleColorMode }) {
  const handleSubmit = (event) => {
    event.preventDefault();
    // Hier kommt die Logik für das Kontaktformular
  };

  return (
    <React.Fragment>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Container 
        component="main" 
        sx={{ 
          mt: { xs: 12, md: 14 }, 
          mb: { xs: 12, md: 14 },
          px: { xs: 2, sm: 3, md: 4 }
        }} 
        maxWidth="lg"
      >
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Kontakt
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 4, backgroundColor: 'background.default' }}>
                <Typography variant="h6" gutterBottom>
                  Schreiben Sie uns
                </Typography>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Vorname"
                        name="firstName"
                        autoComplete="given-name"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Nachname"
                        name="lastName"
                        autoComplete="family-name"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        label="E-Mail"
                        name="email"
                        autoComplete="email"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        label="Nachricht"
                        name="message"
                        multiline
                        rows={4}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                      >
                        Nachricht senden
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 4, height: '100%', backgroundColor: 'background.default' }}>
                <Typography variant="h6" gutterBottom>
                  Kontaktinformationen
                </Typography>
                <Typography variant="body1" paragraph>
                  Sie können uns auch direkt kontaktieren:
                </Typography>
                <Typography variant="body1" paragraph>
                  E-Mail: info@example.com
                </Typography>
                <Typography variant="body1" paragraph>
                  Telefon: +49 (0) 123 456789
                </Typography>
                <Typography variant="body1" paragraph>
                  Geschäftszeiten: Mo-Fr 9:00-17:00 Uhr
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </React.Fragment>
  );
}